import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from 'antd';
import AuthPageShell from '../../../components/AuthPageShell';
import MarketingBrand from './MarketingBrand';
import SignupRequestSection from './SignupRequestSection';

const { Text } = Typography;

const RequestAccessPage: React.FC = () => (
  <AuthPageShell>
    <div className="cp-auth-panel cp-auth-panel--wide">
      <div className="cp-auth-panel__brand">
        <MarketingBrand />
      </div>
      <Typography.Title level={3} className="cp-auth-panel__title">
        Request access
      </Typography.Title>
      <Text type="secondary" className="cp-auth-panel__lead">
        Tell us about your organization. We will review your request and follow up by email.
      </Text>
      <SignupRequestSection />
      <p className="cp-auth-panel__footer">
        Already approved? <Link to="/login">Sign in</Link>
      </p>
    </div>
  </AuthPageShell>
);

export default RequestAccessPage;
